import ShareButton from './ShareButton';
import Share from './Share';

export default Object.assign(ShareButton, { Share });
